import { Fragment, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { T } from "react-translator-component";
import { useAppDispatch } from "../../redux/store";
import { loginAdmin, reset } from "../redux/adminAuthReducer";
import userAuth from "../../util/auth-util";
import setAdminAuthorizationToken from "../../services/axios-util/set-admin-authorization-token";
import LoadingModal from "../../components/LoadingModal";
import ErrorMessageBanner from "../components/ErrorMessageBanner";
import SubmitButton from "../../components/SubmitButton";
import { TextField } from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import { colors } from "../../common/colors";
import { mngStyles } from "../constants/styles";
import clogo from "../../assets/sliderimages/community_logo.png";
import loginimg4 from "../assets/images/loginimg4.png";

const LoginForm = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const [errors, setErrors] = useState<string[]>([]);
  const { isLoading, admin, message } = useSelector(
    (state: any) => state.adminAuth
  );
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const passwordRef = useRef<HTMLInputElement>(null)

  const handleLogin = async () => {
    if (email.trim() !== "" && password.trim() !== "") {
      try {
        const body = { email: email, password: password };
        await dispatch(loginAdmin(body));
        return false
      } catch (error) {
        return false
      }
    } else {
      setErrors([T("mng_login_email_and_password_is_required")]);
      return false
    }
  };

  useEffect(() => {
    if (message) {
      setErrors([message]);
      setTimeout(() => {
        dispatch(reset());
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  useEffect(() => {
    if (admin?.authorization) {
      navigate("/adminhome");
      userAuth.loginUser({ ...admin, isAdmin: true });
      setAdminAuthorizationToken(admin?.authorization);
    } else {
      setAdminAuthorizationToken("");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, admin]);

  return (
    <Fragment>
      <LoadingModal
        visible={isLoading}
      />
      <div className="row  py-5 row-cols-1 row-cols-lg-2">
        <div
          className="feature col d-none d-lg-block py-5"
          style={styles.loginUserContainer}
        >
          <div style={styles.loginUsetrLeftSec}>
            <img
              src={loginimg4}
              alt="BigCo Inc. logo"
              style={styles.loginUserImg}
            />
          </div>
        </div>

        <div className="feature col-12" style={{}}>
          <div
            className="col-12"
            style={{ ...styles.loginUserRightSec, flexDirection: "column" }}
          >
            <img
              src={clogo}
              alt="BigCo Inc. logo"
              style={styles.loginUserCLogo}
            />
            <span style={{ ...mngStyles.tableTitleUser, color: "#313131" }}>
              {T("mng_management_user_login")}
            </span>
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                minWidth: 300,
                alignSelf: "center",
              }}
            >
              <span style={styles.loginFieldTitle}>{T("mng_user_name")}</span>
              <TextField
                placeholder={`${T("mng_admin_user_email")}`}
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
                style={styles.loginUserFiledTxt}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    passwordRef.current?.focus()
                  }
                }}

              />
            </div>
            <div
              style={{ ...styles.loginUserPassField, flexDirection: "column" }}
            >
              <span style={styles.loginUserPassFieldTxt}>{T("mng_admin_user_password")}</span>
              <TextField
                placeholder={`${T("mng_admin_user_password")}`}
                type="password"
                value={password}
                onChange={(ev) => setPassword(ev.target.value)}
                style={styles.loginUserFiledTxt}
                inputRef={passwordRef}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleLogin();
                  }
                }}
              />
            </div>

            <SubmitButton
              style={styles.loginUserLoginBtn}
              size={"large"}
              variant="contained"
              validate={async () => true}
              onSubmit={handleLogin}
            >
              <span style={styles.loginUserLoginBtnTxt}>{T("mng_login")}</span>
            </SubmitButton>
          </div>
        </div>
        <ErrorMessageBanner
          open={errors.length !== 0}
          messages={errors}
          onClose={() => setErrors([])}
        />
      </div>
    </Fragment>
  );
};
export default LoginForm;

const styles = {
  loginUserContainer: { justifyContent: "center" },
  loginUsetrLeftSec: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    alignContent: "flex-end",
  },
  loginUserImg: { width: 400, height: 400, alignSelf: "flex-end" },
  loginUserRightSec: {
    paddingBottom: 20,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    alignContent: "center",
    fontWeight: "600",
    display: "flex",
  },
  loginUserCLogo: {
    width: 100,
    height: 100,
    alignSelf: "center",
    marginBottom: 20,
  },
  loginFieldTitle: {
    fontSize: 16,
    color: "#2596be",
    marginBottom: 5,
    fontWeight: "500",
  },
  loginUserFiledTxt: { fontSize: 22 },
  loginUserPassField: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    marginTop: 20,
    minWidth: 300,
    alignSelf: "center",
  },
  loginUserPassFieldTxt: {
    fontSize: 16,
    color: "#2596be",
    marginBottom: 5,
    fontWeight: "500",
  },
  loginuserForgotSec: {
    marginTop: 10,
    minWidth: 300,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    alignSelf: "center",
    width: "100%",
    maxWidth: 300,
  },
  loginUserForgotSecTxt: {
    fontSize: 14,
    color: "orange",
    textDecoration: "underline",
  },
  loginUserLoginBtn: {
    alignSelf: "center",
    borderRadius: 20,
    backgroundColor: colors.farm_blue200,
    marginTop: 30,
    marginBottom: 20,
  },
  loginUserLoginBtnTxt: { minWidth: 200, color: "#ffffff" },
}
